import { useMutation } from "@apollo/client"
import { TOURNAMENT_MATCH_UPDATE } from "../queries/tournamentMatchUpdate"

interface TournamentMatchUpdateInput {
  id: number
  tournamentId: number
  playerId: number
  opponentId: number
  reset?: boolean
}

export const useTournamentMatchUpdate = () => {
  const [tournamentMatchUpdateMutation, { loading, error }] = useMutation(TOURNAMENT_MATCH_UPDATE)

  const tournamentMatchUpdate = async (input: TournamentMatchUpdateInput) => {
    try {
      const { data } = await tournamentMatchUpdateMutation({
        variables: { TournamentMatchUpdateInput: input },
      })
      return data?.TournamentMatchUpdate
    } catch (mutationError) {
      console.error("Error updating tournament match:", mutationError)
      throw mutationError
    }
  }

  return {
    tournamentMatchUpdate,
    loading,
    error,
  }
}
